import Flickity from "../../build/webpack/node_modules/flickity";
import pegasus from "../../build/global/js/00-pegasus";

window.testimonialSlider = () => {
    return {
        slider: null,
        sliderContainer: null,
        sliderOptions: {},
        visible: false,
        currentSlide: 1,
        sliderEnd: false,
        initSlider(elem){
            this.sliderContainer = elem;

            let defaults = {
                cellAlign: 'center',
                wrapAround: true,
                pageDots: false,
                freeScroll: false,
                prevNextButtons: true,
                arrowShape: 'M7.15836 10.8335L17.1667 10.8335L17.1667 9.16683L7.15836 9.16683L7.15836 6.66683L3.83336 10.0002L7.15836 13.3335L7.15836 10.8335Z',
                on: {
                    ready: function() {
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'));
                        }, 500);
                        
                    },
                }
            }

            let options = {};

            this.sliderOptions = pegasus.extend(defaults, options);

            if(window.outerWidth < 768 || (window.outerWidth < 768 && Modernizr.touch)){
                if(this.slider !== null){
                    this.slider.destroy();
                }
            } else {
                this.slider = new Flickity(this.sliderContainer, this.sliderOptions);
                this.eventListeners();
            }

            //this.slider = new Flickity(this.sliderContainer, this.sliderOptions);
                this.eventListeners();

            pegasus.onResizeFinished(() => {
                this.resizeSlider();
                this.slider.resize();
                this.slider.reposition();
            });


        },
        eventListeners(){
            this.slider.on('change', slide => {
                this.currentSlide = slide;
            });
            this.slider.on('scroll', e => {
                this.sliderEnd = e.toFixed(2) >= 1;
            });
        },
        goToSlide(slide){
            this.slider.select(slide);
        },
        resizeSlider(){
            if(window.outerWidth < 768){
                if(this.slider !== null){
                    this.slider.destroy();
                }
            } else {
                this.slider = new Flickity(this.sliderContainer, this.sliderOptions);
            }
        }
    }
}